import AppConfig from './AppConfig';

const EndPointList = {
    getColors: `${AppConfig.baseUrl}/api/colors`,
    getMockupCategories: `${AppConfig.baseUrl}/api/mockup-categories`,
    getMockups: `${AppConfig.baseUrl}/api/mockups`,
    getMockup: `${AppConfig.baseUrl}/api/mockup`,
    getAdminfonts: `${AppConfig.baseUrl}/api/fonts`,
    getGooglefonts: `https://www.googleapis.com/webfonts/v1/webfonts?key=${AppConfig.googleApiKey}`,
    getElementCategories: `${AppConfig.baseUrl}/api/element-categories`,
    getElements: `${AppConfig.baseUrl}/api/elements`,
    postUploads: `${AppConfig.baseUrl}/api/upload-image?image=`,
    
};

export default EndPointList;